
/**
 * First we will load all of this project's JavaScript dependencies, jquery for clinic
 */

import Vue from 'vue'
import Deals from './components/deals'
import Presentation from './components/presentation'

require('./bootstrap')

const app = new Vue({
    components: {
        Deals,
        Presentation
    }
}).$mount('#vueApp')

// Sets variable screen width used for responsive javascripts
let window_width = Math.min(window.innerWidth || Infinity, screen.width)

// css sizes and breakpoints
const mobile_break = 700
const tablet_break = 1100

let mobmenuvis = false
const motMapVis = false
const motListVis = true

// Default validate regex taken from chrome source code
function validateEmail (email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

// Gets url parameters by name, default to page url if url empty
function getParameterByName (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function resizeHeader () {
    if (jQuery(window).scrollTop() > 80) {
        jQuery('.header').addClass('sticky')
        jQuery('body').addClass('has-sticky-menu')
    }

    if (jQuery(window).scrollTop() < 100) {
        jQuery('.header').removeClass('sticky')
        jQuery('body').removeClass('has-sticky-menu')
    }
}

// responsive changes on window resize
jQuery(window).resize(function () {
    // Sets variable screen width used for responsive javascripts
    window_width = Math.min(window.innerWidth || Infinity, screen.width)

    if (window_width >= mobile_break) {
  	jQuery('.mobile-nav-menu').fadeOut(200)
        mobmenuvis = false
    }
})

jQuery(window).scroll(function () {
    resizeHeader()
})

jQuery(document).ready(function ($) {
    $('body').removeClass('preload')

    resizeHeader()

    $('.mobile-nav-button').click(function (event) {
        if (mobmenuvis == false) {
            $('.mobile-nav-menu').slideDown(400)
            mobmenuvis = true
        } else {
            $('.mobile-nav-menu').slideUp(400)
            mobmenuvis = false
        }
    })

    $('.addWebbAppBg').click(function (event) {
        closeWebappMessage()
    })

    $('.add-app-close').click(function (event) {
        closeWebappMessage()
    })

    $('#punch_validate').click(function (event) {
        punchTreatment('validate')
    })

    $('#punch_confirm').click(function (event) {
        punchTreatment('confirm')
    })

    $('#punch_close').click(function (event) {
        $('.confirm-treatment').hide()
    })


    $( "body" ).on( "click", ".fold-container .title", function() {
      console.log(event.target)

        if (!$(event.target).is('.pdf-link')) {
            $(this).closest('.fold-container').toggleClass('folded')
        }
    });

    // $('.fold-container .title').click(function (event) {
    //     console.log(event.target)

    //     if (!$(event.target).is('.pdf-link')) {
    //         $(this).closest('.fold-container').toggleClass('folded')
    //     }
    // })

    $('.mobile-menu-button').click(function (event) {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $('.navigation-menu').removeClass('active')
        } else {
            $(this).addClass('active')
            $('.navigation-menu').addClass('active')
        }
    })

    $('#booking_link').change(function (event) {
        const val = $(this).val()

        if (val) {
            $('#booking_instructions_group').show()
        } else {
            $('#booking_instructions_group').hide()
            $('#booking_instructions').val('')
        }
    })

    $('#booking_link').keyup(function (event) {
        const val = $(this).val()

        if (val) {
            $('#booking_instructions_group').show()
        } else {
            $('#booking_instructions_group').hide()
            $('#booking_instructions').val('')
        }
    })

    $('#account_change_payment_type').change(function (event) {
        const val = $(this).val()

        if (val == 1) {
            $('#payment_account_label_1').show()
            $('#payment_account_label_2').hide()
            $('#payment_account_label_3').hide()

            $('#payment_account_group').show()
            $('#payment_bank_group').show()
            $('#payment_clearing_group').show()
        }

        if (val == 2) {
            $('#payment_account_label_1').hide()
            $('#payment_account_label_2').show()
            $('#payment_account_label_3').hide()

            $('#payment_account_group').show()
            $('#payment_bank_group').hide()
            $('#payment_clearing_group').hide()
        }

        if (val == 3) {
            $('#payment_account_label_1').hide()
            $('#payment_account_label_2').hide()
            $('#payment_account_label_3').show()

            $('#payment_account_group').show()
            $('#payment_bank_group').hide()
            $('#payment_clearing_group').hide()
        }

        if (val == 0) {
            $('#payment_account_group').hide()
            $('#payment_bank_group').hide()
            $('#payment_clearing_group').hide()
        }

        $('#payment_account').val('')
        $('#payment_bank').val('')
        $('#payment_clearing').val('')
    })

    $('input[name="reason"]').click(function () {
        console.log($(this).val())

        if ($(this).val() == 'no_show') {
            $('#no_showReasonContainer').show()
        } else {
            $('#no_showReasonContainer').hide()
        }

        if ($(this).val() == 'late_cancelling') {
            $('#late_cancellingReasonContainer').show()
        } else {
            $('#late_cancellingReasonContainer').hide()
        }

        if ($(this).val() == 'no_app') {
            $('#no_appReasonContainer').show()
        } else {
            $('#no_appReasonContainer').hide()
        }

        if ($(this).val() == 'forgot') {
            $('#forgotReasonContainer').show()
        } else {
            $('#forgotReasonContainer').hide()
        }

        if ($(this).val() == 'other') {
            $('#otherReasonContainer').show()
        } else {
            $('#otherReasonContainer').hide()
        }

        if ($(this).val() == 'tech_issue') {
            $('#techReasonContainer').show()
        } else {
            $('#techReasonContainer').hide()
        }
    })

    $('#deviation_form').on('submit', function () {
        $('#deviation_submit').attr('disabled', 'disabled')
    })

    // Browser
    if (!window.matchMedia('(display-mode: standalone)').matches && (!('standalone' in window.navigator) || (('standalone' in window.navigator) && !window.navigator.standalone))) {
	    jQuery('body').addClass('browser')
    }

    // Standalone PWA
    if (window.matchMedia('(display-mode: standalone)').matches || (('standalone' in window.navigator) && window.navigator.standalone)) {
	    jQuery('body').addClass('standalone')
    }

    $('.deviation-history .deviation-row .fold-icon').click(function (event) {
        if (window_width <= 991) {
            if ($(this).parent().parent().hasClass('folded')) {
                $(this).parent().parent().removeClass('folded')
            } else {
                $(this).parent().parent().addClass('folded')
            }
        }
    })

    $('.copy-code').click(function (event) {
        const copy_target_id = $(this).attr('id')
        const text = $('#code_' + copy_target_id).html()
        navigator.clipboard.writeText(text)
        $(this).find('.confirmation').addClass('show')
        const _this = $(this)
        setTimeout(function () {
            _this.find('.confirmation').removeClass('show')
        }, 2000)
    })

    if ($('#treatments_wrapper').length) {
        $.ajax({
            url: '/loadTreatments',
            type: 'GET'
        })
            .done(function (data) {
                $('#treatments_wrapper').html(data)
            })
    }
})

function setCookie (cName, cValue, expDays) {
    const date = new Date()
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + date.toUTCString()
    document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/'
}

function closeWebappMessage () {
    $('.addWebbAppBg').addClass('hidden')
    $('.addWebbApp').addClass('hidden')
    setCookie('hideWebAppMessage', '1', 1)
}

function punchTreatment (mode) {
    const code = $('#punch_code').val()

    console.log('sending punch treatment')

    $.ajax({
        url: '/punch',
        type: 'POST',
        data: { code: code, mode: mode }
    })
        .done(function (data) {
            if (mode == 'validate') {
                if (data.error == false) {
                    $('#punch_error').hide()
                    $('.confirm-treatment').show()

                    $('#treatment_confirmation').html(data.customerName + ' ' + data.treatmentLength + ' minuter')
                } else {
                    if (data.message == 'notFound') {
                        $('#punch_error').html('Ogiltig kod.')
                    }
                    if (data.message == 'isUsed') {
                        $('#punch_error').html('Koden är redan använd.')
                    }
                    if (data.message == 'expiredCard') {
                        $('#punch_error').html('Klippkortet är inte längre giltigt.')
                    }
                    $('#punch_error').show()
                }
            }

            if (mode == 'confirm') {
                if (data.error == false) {
                    $('#punch_code').val('')
                    $('#punch_success').html('Klippet har registrerats, kunden har nu ' + data.message + ' klipp kvar.')
                    $('#punch_success').show()
                    $('.confirm-treatment').hide()
                } else {
                    console.error('Server side error when posting confirm manual punch')
                }
            }
        })
        .fail(function (data) {
            console.error('Server side error when posting manual punch')
        })
}
